import React from "react";
import { connect } from "react-redux";
import { fetchUser } from "../../../actions";
import Spinner from "../../atoms/Spinner";
import RegistrationFormEdit from '../../organisms/RegistrationFormEdit/index'
import { Redirect } from "react-router-dom";

class RegistrationFormPage extends React.PureComponent {
  constructor(props) {
    super();
    this.state = {
      showEditPIForm: false,
    
    }
    this.showEditPIForm = this.showEditPIForm.bind(this);
  }
  componentDidMount() {
    this.props.dispatch(fetchUser());
  }
  showEditPIForm() {
    this.setState({showEditPIForm: true})
  }
  render() {
    const { error, loading,Status } = this.props;


    if (error) {
      if (error.response && error.response.status===401) {
        return <Redirect to="/error/authentication" />;
      } else {
      return <div>Error! {error.message}</div>;
      }
    }

    if (loading || this.props.step < 1) {
      return (
        <div align="center">
          <Spinner />
        </div>
      );
    }
    if (Status!=='kycREVIEW') return <Redirect to="/dashboard" />
    return <RegistrationFormEdit />
    
  }
}

const mapStateToProps = state => ({
  User: state.User,
  AffiliateStatus: state.AffiliateStatus,
  loading: state.loading,
  error: state.errorLoading,
  step: state.processState,
  salesStep: state.salesStep,
  Status: state.Status,
});

export default connect(mapStateToProps)(RegistrationFormPage);
